<div [class.slider-embedded]="!showHeading" class="slider-layout max-w-[1440px] mx-auto w-full px-6 py-12 font-sans overflow-hidden">
    @if (showHeading) {
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-16 px-4">
        <h2 class="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight max-w-md leading-tight">
            Explore Our <br />
            Private Listing
        </h2>
        <p class="text-xl text-gray-600 max-w-sm mt-4 md:mt-0 leading-relaxed">
            Experience The Elegance Of Our Most Sought-After Listings - Refined, Rare,
            And Ready To Inspire.
        </p>
    </div>
    }
    @if (!showHeading && carouselData.length) {
    <div class="gallery-toolbar">
      <span>Featured residences <small>· Swipe or drag to explore</small></span>
      <div>
        <button type="button" aria-label="Previous property" (click)="moveSlide(-1)"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg></button>
        <button type="button" aria-label="Next property" (click)="moveSlide(1)"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg></button>
      </div>
    </div>
    }
    <div class="relative w-full">
        @if (!carouselData.length && !loading) {
          <div class="carousel-status" role="status">
            @if (loadError) { <p>Featured residences couldn’t be loaded.</p><button type="button" (click)="getCarouselData()">Try again</button> }
            @else { <p>No featured residences are available right now.</p> }
          </div>
        }

        <div #slider (scroll)="onScroll()" (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)" class="carousel-track flex gap-10 overflow-x-auto px-[8%] md:px-[12%] pb-28 pt-16 items-center no-scrollbar cursor-grab active:cursor-grabbing select-none touch-pan-x ">
            @if (loading && !carouselData.length) {
              <span class="sr-only" role="status">Loading featured residences…</span>
              <div *ngFor="let placeholder of [1, 2, 3, 4]" class="carousel-skeleton" aria-hidden="true">
                <div class="skeleton-block skeleton-photo"></div>
                <div class="skeleton-copy">
                  <div class="skeleton-block skeleton-title"></div>
                  <div class="skeleton-block skeleton-location"></div>
                  <div class="skeleton-block skeleton-price"></div>
                  <div class="skeleton-metrics"><div class="skeleton-block"></div><div class="skeleton-block"></div></div>
                  <div class="skeleton-block skeleton-button"></div>
                </div>
              </div>
            }
            <div *ngFor="let img of dynamicloopImages; let i = index" class="property-card card-container shrink-0 w-[300px] md:w-[380px] h-[450px] md:h-[500px]  -mx-3 md:-mx-3  relative rounded-2xl overflow-hidden transition-all duration-500 ease-in-out" [ngClass]="{
            'scale-[1.05] z-20 opacity-100 shadow-[0_20px_60px_rgba(0,0,0,0.25)]':
                activeIndex === i % carouselData.length,

            'scale-[0.94] z-0 opacity-85':
                activeIndex !== i % carouselData.length
                        }">
                            <div class="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
                            <img [src]="img.galleryImage[0]" draggable="false" class="w-full h-full object-cover transition-transform duration-700 ease-out" [ngClass]="{
            'scale-105': activeIndex === i % carouselData.length,
            'scale-100': activeIndex !== i % carouselData.length
            }" />
                <div *ngIf="backendBadgeLabel(img.possession) as possession" class="property-possession absolute top-5 right-5">
                    <span class="inline-flex items-center rounded-sm bg-[#EFEFEF] px-2 py-2 text-xs font-normal text-black gap-2">
                        <i class="fa fa-tag text-gray-500" aria-hidden="true"></i> {{ possession }}
                    </span>
                </div>
                <div class="absolute bottom-4 right-2 left-2">
                    <div class="content-start bg-white/70 backdrop-blur-sm rounded-2xl p-5 border border-white/20 shadow-[0_10px_40px_rgba(0,0,0,0.15)]">
                        <div class="flex flex-row gap-x-6">
                            
                            <div class="flex flex-col gap-2">
                                <h3 class="text-lg font-semibold leading-tight">
                                    {{ img.name | titlecase }}
                                </h3>
                                <p class="text-xs text-gray-800">
                                    <!-- {{formatAddress(img)}} -->
                                    {{img.microMarket.micromarketName}} | {{img.microMarket.cluster}}
                                </p>
                                <div class="flex items-center gap-2 mt-2">
                                    <p class="text-[16px] font-semibold">
                                        <span class="text-lg font-semibold" *ngIf="getPriceRange(img.price) as range">
                                            {{ range.min | inrShort }}
                                            <ng-container *ngIf="!range.isSame">
                                            <span class="text-gray-800 font-light mx-1">-</span>
                                            {{ range.max | inrShort }}
                                            </ng-container>
                                        </span>
                                    </p>
                                    <p class="text-xs border-l-1 border-black/10 text-gray-600 pl-2 leading-5"
                                        [innerHTML]="formatPropertyDetails(img.price)">
                                    </p>
                                </div>
                            </div>
                        </div>
                        <section class="property-ci" aria-label="Circled Intelligence summary">
                            <div class="property-ci-brand"><svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 2 3 7 7 3-7 3-3 7-3-7-7-3 7-3Z"/></svg><span>Circled Intelligence</span></div>
                            <dl class="property-ci-metrics">
                                <div class="property-ci-assessment"><dt>CI Assessment</dt><dd>{{ ciVerdict(img) || 'Not available' }}</dd></div>
                                <div class="property-ci-yield"><dt>Rental Yield</dt><dd>{{ ciRentalYield(img) }}</dd></div>
                            </dl>
                        </section>
                        <div class="flex">
                            <button 
                                *ngIf="!showHeading || activeIndex === (i % carouselData.length)"
                                (click)="$event.stopPropagation(); isView(img)" 
                                (pointerdown)="$event.stopPropagation()"
                                class="relative z-50 bg-black/80 text-white text-sm font-bold px-5 py-2.5 rounded-full  cursor-pointer opacity-0 translate-y-3 transition-all duration-500" [ngClass]="{
'opacity-100 translate-y-0': activeIndex === i % carouselData.length
}">
                                View property
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            @if (carouselData.length) {
            <div class="card-container carousel-explore-card shrink-0 relative overflow-hidden">
                <div class="explore-brand">
                    <img src="/cir-home/images/circledplus-logo.svg" alt="CircledPlus" width="140" height="36" />
                </div>
                <div class="carousel-explore-copy">
                    <h2>Find your home.<br><em>Know its worth.</em></h2>
                    <p class="explore-description">Exceptional residences. A clearer perspective with Circled Intelligence.</p>
                    <ul class="explore-benefits" aria-label="Circled Intelligence insights">
                        <li><span class="benefit-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M5 19v-5m7 5V9m7 10V4"/></svg></span><div><strong>Price in perspective</strong><p>Understand the market benchmark.</p></div></li>
                        <li><span class="benefit-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="m3 8 9-5 9 5-9 5-9-5Zm0 5 9 5 9-5M3 18l9 5 9-5"/></svg></span><div><strong>Potential, uncovered</strong><p>Explore rental yield and land insights.</p></div></li>
                        <li><span class="benefit-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="m6 18 12-12"/><circle cx="7" cy="7" r="2.5"/><circle cx="17" cy="17" r="2.5"/></svg></span><div><strong>Confidence to negotiate</strong><p>Let the evidence guide your offer.</p></div></li>
                    </ul>
                </div>
                <div class="explore-footer">
                    <dl class="explore-stats">
                        <div><dt>Listings</dt><dd>300+</dd></div>
                        <div><dt>Micro-markets</dt><dd>25+</dd></div>
                    </dl>
                    <button type="button" (click)="exploreAll(); $event.stopPropagation()" (pointerdown)="$event.stopPropagation()">
                        Explore all listings
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>
                    </button>
                </div>
            </div>
            }
        </div>
    </div>

    <!-- PROGRESS -->
    @if(carouselData.length > 0){
    <div class="flex justify-center items-center gap-4 md:gap-8 mb-4">
        <button type="button" *ngFor="let item of carouselData; let i = index" (click)="scrollToIndex(i)" [attr.aria-label]="'Show property ' + (i + 1)" [attr.aria-current]="activeIndex === i ? 'true' : null" class="carousel-progress flex flex-col items-center gap-2 w-16 md:w-24">
            <div class="h-[2px] w-full bg-gray-200 overflow-hidden">
                <div class="h-full bg-black transition-all duration-700 ease-out" [style.width]="activeIndex === i ? '100%' : '0%'"></div>
            </div>
            <span class="text-xs transition-colors duration-300" [class.text-black]="activeIndex === i" [class.font-bold]="activeIndex === i" class="text-gray-400">
                0{{ i + 1 }}
            </span>
        </button>
    </div>
}
</div>
